const routes = [{
  path: '/feiche/export/template',
  component: () => import('@/views/finance/exportTemplate'),
  name: 'feiche-export-template',
  meta: {
    title: '导出模版设置'
  }
}, {
  path: '/feiche/product',
  component: () => import('@/views/feiche/product'),
  name: 'feiche-product',
  meta: {
    title: '产品管理'
  }
}, {
  path: '/feiche/orderSetting',
  component: () => import('@/views/feiche/orderSetting'),
  name: 'feiche-orderSetting',
  meta: {
    title: '保单设置'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/setting.js